import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { getQuestionSubjects } from "../../../actions/adminQuestionActions";

import Loader from "../../Loader";

const ListQuestionSubjects = ({ history }) => {
  const dispatch = useDispatch();

  const { questionSubjects, loading, subjectPagination } = useSelector(
    (state) => state.questions
  );
  const [page, setPage] = useState(1);
  const limit = subjectPagination?.limit || 20;

  useEffect(() => {
    dispatch(getQuestionSubjects(page, limit));
  }, [dispatch, page, limit]);

  const handleOnClickSubject = (e, data) => {
    e.preventDefault();
    localStorage.setItem("subjectName", data.slug);
    history.push(`/admin/subject-years/${data._id}`);
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small>Question Subjects</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li className="active">Question Subjects</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">Question Subjects</h3>
                      <div className="box-tools">
                        <Link
                          to="/admin/question-bank-search"
                          className="btn btn-info btn-sm"
                          style={{ marginRight: "8px" }}
                        >
                          <i className="fa fa-search"></i> Global Search
                        </Link>
                        <Link
                          to={"/admin/question-subjects/add"}
                          className="btn btn-success btn-sm"
                        >
                          + Add Question Subject
                        </Link>
                      </div>
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Subject</th>
                            <th>Total Questions</th>
                            <th>Years</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(questionSubjects) &&
                          questionSubjects.length ? (
                            questionSubjects.map((item, idx) => {
                              const examKey =
                                item?._id || item?.examName || `exam-${idx}`;
                              const subjects = Array.isArray(item?.subjects)
                                ? item.subjects
                                : [];

                              return (
                                <Fragment key={examKey}>
                                  <tr className="table-section-heading">
                                    <td colSpan="3">
                                      <strong>
                                        Exam Name: {item?.examName || "N/A"}
                                      </strong>
                                    </td>
                                  </tr>
                                  {subjects.length ? (
                                    subjects.map((sub) => (
                                      <tr
                                        key={
                                          sub?._id ||
                                          `${examKey}-${sub?.title || "subject"}`
                                        }
                                      >
                                        <td>{sub?.title}</td>
                                        <td>{sub?.totalQuestions}</td>
                                        <td>
                                          <Link
                                            to="#"
                                            onClick={(e) =>
                                              handleOnClickSubject(e, sub)
                                            }
                                            className="btn btn-success btn-sm"
                                            title="View"
                                          >
                                            <i className="fa fa-eye"></i>
                                          </Link>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr key={`${examKey}-empty`}>
                                      <td colSpan="3">
                                        No subjects found for this exam.
                                      </td>
                                    </tr>
                                  )}
                                </Fragment>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="3">No records found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div
                        className="pagination-controls"
                        style={{ padding: "10px" }}
                      >
                        <button
                          className="btn btn-default btn-sm"
                          disabled={loading || page <= 1}
                          onClick={() => setPage((p) => Math.max(p - 1, 1))}
                        >
                          Prev
                        </button>
                        <span style={{ margin: "0 10px" }}>
                          Page {subjectPagination?.page || page} of{" "}
                          {subjectPagination?.totalPages || 1}
                        </span>
                        <button
                          className="btn btn-default btn-sm"
                          disabled={
                            loading ||
                            (subjectPagination?.page || 1) >=
                              (subjectPagination?.totalPages || 1)
                          }
                          onClick={() => setPage((p) => p + 1)}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListQuestionSubjects;
